import {
	BOOK_EXTERNAL_HTML_REQUEST,
	BOOK_EXTERNAL_PAYMENT_REQUEST,
	BOOK_EXTERNAL_PAYMENT_SUCCESS,
	BOOK_REQUEST,
	BOOK_SUCCESS,
	CHECK_AVAILABILITIES_SUCCESS,
	PRE_BOOK_REQUEST,
	PRE_BOOK_SUCCESS,
	RESTORE_BOOKING_SESSION_REQUEST,
	RESTORE_BOOKING_SESSION_SUCCESS,
	SEND_PROMOTION_CODE_SUCCESS,
	UPDATE_EXTERNAL_BOOK_STATUS,
} from "app/actionTypes";
import { BOOK_STATUS, PAYMENT_METHODS, PAYMENT_TERMS, PRE_BOOK_CODE_STATUS } from "app/constants";
import get from "lodash/get";
import { CHECK_SDP_AVAILABILITIES_SUCCESS } from "app/pages/SmartDP/smartDPActionTypes";
import {
	HOTEL_ONLY_PREBOOK_REQUEST,
	HOTEL_ONLY_PREBOOK_SUCCESS,
} from "app/pages/HotelOnly/Booking/pages/Quote/BookingQuoteActionCreator";
import {
	RESTORE_BOOKING_SESSION_STOPOVER_REQUEST,
	RESTORE_BOOKING_SESSION_STOPOVER_SUCCESS,
} from "app/pages/Stopover/stopoverActionTypes";

const initialPayment = {
	bookStatus: undefined,
	dateOfBirthRequired: false, // dateOfBirthRequired = true means that adults birthdates must be sent to the /book payload

	paymentSwissbilling: {
		maxAmount: 3500,
	},
	showFrequentTravellerCardInput: false,
	paymentTypes: [],
	insurances: {},
	timestamp: undefined, // timestamp utilisé pour l'encryption adyen CB
	deltaBasePrice: 0,
	priceChange: {},
	restoreSessionDepositToPay: 0, // montant de l'acompte à payer par le client venant de l'outil sales tool
};

export default (payment = initialPayment, action) => {
	switch (action.type) {
		case RESTORE_BOOKING_SESSION_STOPOVER_REQUEST:
		case RESTORE_BOOKING_SESSION_REQUEST:
		case HOTEL_ONLY_PREBOOK_REQUEST:
		case PRE_BOOK_REQUEST:
			// éviter que le logo de paiement 4X disparaisse lors du clic sur le bouton Réserver maintenant de la page Quote
			return Object.assign({}, initialPayment, {
				paymentTypes: payment.paymentTypes,
				paymentSwissbilling: payment.paymentSwissbilling, // ne pas réécraser les infos de paiement 4x par brand (elles sont récupérées une seule fois au démarrage de l'application)
			});
		case BOOK_REQUEST:
			return Object.assign({}, payment, { bookStatus: undefined });
		case BOOK_SUCCESS:
		case BOOK_EXTERNAL_PAYMENT_SUCCESS:
			return Object.assign({}, payment, { bookStatus: action.res.data.status });
		case HOTEL_ONLY_PREBOOK_SUCCESS:
		case PRE_BOOK_SUCCESS: {
			const preBookStatus = action.res.data.status;

			const paymentTypes = get(action, "res.data.paymentTypes") || [];
			const paymentSwissbillingType =
				paymentTypes.find(
					paymentType => paymentType.paymentType === PAYMENT_METHODS.SWISS_BILLING
				) || initialPayment.paymentSwissbilling;
			return Object.assign({}, payment, {
				insurances: action.res.data.insurances || {},
				paymentTypes: action.res.data.paymentTypes || [],
				timestamp: action.res.data.timestampISO8601,
				dateOfBirthRequired: action.res.data.dobRequired,
				contractRemarks: action.res.data.contractRemarks,
				showFrequentTravellerCardInput: action.res.data.showFrequentTravellerCardInput,
				bookStatus: undefined,
				paymentSwissbilling: { maxAmount: paymentSwissbillingType.maxAmount },
				priceChange:
					preBookStatus === PRE_BOOK_CODE_STATUS.WARNING
						? action.res.data.priceChange
						: {},
				deltaBasePrice:
					preBookStatus === PRE_BOOK_CODE_STATUS.WARNING
						? action.res.data.priceChange.newPrice -
							action.res.data.priceChange.oldPrice
						: 0,
			});
		}
		case RESTORE_BOOKING_SESSION_STOPOVER_SUCCESS:
		case RESTORE_BOOKING_SESSION_SUCCESS: {
			const { preBookResponse = {}, bookRequest = {} } = action.res.data;
			const preBookStatus = preBookResponse.status;

			const paymentTypes = preBookResponse.paymentTypes || [];
			const paymentSwissbillingType =
				paymentTypes.find(
					paymentType => paymentType.paymentType === PAYMENT_METHODS.SWISS_BILLING
				) || initialPayment.paymentSwissbilling;

			const restoreSessionOnlyPaymentType = paymentTypes.find(
				paymentType => paymentType?.terms === PAYMENT_TERMS["1x"]
			);

			const restoreSessionDepositToPay = bookRequest?.payment?.amount || 0;

			return {
				insurances: preBookResponse.insurances || {},
				restoreSessionDepositToPay,
				paymentTypes:
					restoreSessionDepositToPay > 0 && restoreSessionOnlyPaymentType
						? [restoreSessionOnlyPaymentType]
						: paymentTypes,
				timestamp: preBookResponse.timestampISO8601,
				dateOfBirthRequired: preBookResponse.dobRequired,
				contractRemarks: preBookResponse.contractRemarks,
				showFrequentTravellerCardInput: preBookResponse.showFrequentTravellerCardInput,
				bookStatus: undefined,
				paymentSwissbilling: { maxAmount: paymentSwissbillingType.maxAmount },
				priceChange:
					preBookStatus === PRE_BOOK_CODE_STATUS.WARNING
						? preBookResponse.priceChange
						: {},
				deltaBasePrice:
					preBookStatus === PRE_BOOK_CODE_STATUS.WARNING
						? preBookResponse.priceChange.newPrice -
							preBookResponse.priceChange.oldPrice
						: 0,
			};
		}
		case SEND_PROMOTION_CODE_SUCCESS:
		case CHECK_SDP_AVAILABILITIES_SUCCESS:
		case CHECK_AVAILABILITIES_SUCCESS:
			return Object.assign({}, payment, {
				paymentTypes: action.res.data.paymentTypes || [],
			});
		case BOOK_EXTERNAL_PAYMENT_REQUEST:
		case BOOK_EXTERNAL_HTML_REQUEST:
			return Object.assign({}, payment, {
				bookStatus: BOOK_STATUS.LOADING,
			});
		case UPDATE_EXTERNAL_BOOK_STATUS:
			return Object.assign({}, payment, {
				bookStatus: action.bookStatus,
			});
		default:
			return payment;
	}
};
